import { useEffect, useRef, useState } from "react";

export default function TextScroll({ selectedItem }) {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    if (!selectedItem) {
      setShouldScroll(false);
      setStartAnimation(false);
      return;
    }

    // Reset animation khi item thay đổi
    setStartAnimation(false);

    const checkOverflow = () => {
      if (!textRef.current || !containerRef.current) return false;
      return textRef.current.scrollWidth > containerRef.current.clientWidth;
    };

    const isOverflowing = checkOverflow();

    setShouldScroll(isOverflowing);

    if (isOverflowing) {
      // Delay 1 giây rồi mới bắt đầu scroll
      const timer = setTimeout(() => {
        setStartAnimation(true);
      }, 1000); // ← 1000ms = 1 giây

      return () => clearTimeout(timer);
    } else {
      setStartAnimation(false);
    }

    // Responsive: check lại khi resize
    const handleResize = () => {
      const overflowing = checkOverflow();
      setShouldScroll(overflowing);
      if (!overflowing) setStartAnimation(false);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [selectedItem]);

  if (!selectedItem) return null;

  return (
    <div className="flex flex-col items-center text-sm text-primary font-bold">
      <span className="text-sm">{selectedItem.value}</span>

      <div ref={containerRef} className="relative mt-1 w-full overflow-hidden text-center">
        <p
          key={selectedItem?.option_text}
          ref={textRef}
          className={`
            inline-block whitespace-nowrap text-base xs:text-xl
            ${shouldScroll && startAnimation ? 'animate-scroll' : ''}
          `}
        >
          {selectedItem.option_text}
        </p>
      </div>
    </div>
  );
}
